// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MoveNode__container___h0guO {
    margin-bottom: 14px;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(173, 139, 62, 0.25);
}

.MoveNode__label___vNV1e {
    display: block;
    margin: 0 0 6px 2px;
    color: rgba(210, 205, 190, 0.64);
    font-size: 10px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.MoveNode__moveModes___v_enM {
    display: grid;
    gap: 5px;
    margin: 15px 0 13px;
    padding: 0;
}

.MoveNode__moveModeLabel___Az63J {
    margin: 0 0 2px 2px;
    color: rgba(210, 205, 190, 0.64);
    font-size: 10px;
    letter-spacing: 0.09em;
    line-height: 1.4;
    text-transform: uppercase;
}

.MoveNode__moveMode___vyWYy {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 7px;
    align-items: center;
    padding: 5px 7px;
    border: 1px solid rgba(173, 139, 62, 0.16);
    color: rgba(235, 230, 211, 0.76);
    cursor: pointer;
    font-family: monospace;
    font-size: 12px;
}

.MoveNode__moveMode___vyWYy:has(input:checked) {
    border-color: rgba(222, 174, 70, 0.42);
    background: rgba(116, 83, 25, 0.16);
    color: #fff5ce;
}

.MoveNode__moveMode___vyWYy:has(input:disabled) {
    cursor: default;
    opacity: 0.42;
}

.MoveNode__moveMode___vyWYy small {
    color: rgba(210, 205, 190, 0.46);
}

.MoveNode__moveAction___lsAQp {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}

.MoveNode__searchRow___x_i1i {
    display: flex;
    gap: 8px;
    align-items: center;
}

.MoveNode__searchInput___eCiH6 {
    box-sizing: border-box;
    width: 100%;
    height: 36px;
    padding: 7px 9px;
    border: 1px solid rgba(173, 139, 62, 0.28);
    border-radius: 2px;
    outline: none;
    background: rgba(0, 0, 0, 0.42);
    color: rgba(235, 230, 211, 0.9);
    font-family: monospace;
    font-size: 14px;
}

.MoveNode__searchInput___eCiH6:focus {
    border-color: rgba(222, 174, 70, 0.62);
    box-shadow: 0 0 7px rgba(222, 174, 70, 0.24);
}

.MoveNode__results___IUQ2w {
    margin-top: 5px;
    border: 1px solid rgba(173, 139, 62, 0.22);
    background: rgba(2, 3, 3, 0.94);
}

.MoveNode__result___riCow {
    display: flex;
    width: 100%;
    min-width: 0;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 10px;
    border: 0;
    border-bottom: 1px solid rgba(173, 139, 62, 0.14);
    background: transparent;
    color: rgba(235, 230, 211, 0.84);
    text-align: left;
    white-space: nowrap;
}

.MoveNode__result___riCow:last-child {
    border-bottom: 0;
}

.MoveNode__result___riCow:hover,
.MoveNode__result___riCow:focus {
    outline: none;
    background: rgba(116, 83, 25, 0.24);
    color: #fff5ce;
}

.MoveNode__result___riCow small {
    flex: none;
    color: rgba(210, 205, 190, 0.46);
}

.MoveNode__result___riCow > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.MoveNode__selection___P3xAW {
    margin: 9px 2px 0;
    line-height: 1.45;
    color: rgba(210, 205, 190, 0.62);
    font-family: monospace;
    font-size: 12px;
    font-weight: normal;
}

.MoveNode__spinner___QI0hs {
    padding: 8px 0 2px;
    text-align: center;
}

.MoveNode__selection___P3xAW strong {
    margin-left: 5px;
    color: #d9bf72;
}

@media (max-width: 520px) {
    .MoveNode__searchRow___x_i1i {
        align-items: flex-start;
        flex-direction: column;
    }

    .MoveNode__result___riCow small {
        display: none;
    }

    .MoveNode__moveMode___vyWYy {
        grid-template-columns: auto 1fr;
    }

    .MoveNode__moveMode___vyWYy small {
        display: none;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MoveNode__container___h0guO`,
	"label": `MoveNode__label___vNV1e`,
	"moveModes": `MoveNode__moveModes___v_enM`,
	"moveModeLabel": `MoveNode__moveModeLabel___Az63J`,
	"moveMode": `MoveNode__moveMode___vyWYy`,
	"moveAction": `MoveNode__moveAction___lsAQp`,
	"searchRow": `MoveNode__searchRow___x_i1i`,
	"searchInput": `MoveNode__searchInput___eCiH6`,
	"results": `MoveNode__results___IUQ2w`,
	"result": `MoveNode__result___riCow`,
	"selection": `MoveNode__selection___P3xAW`,
	"spinner": `MoveNode__spinner___QI0hs`
};
module.exports = ___CSS_LOADER_EXPORT___;
